<div class="search-box">
    @if (!verPreguntas) {
        <form role="form" [attr.aria-label]="title" [formGroup]="searchForm" class="search-box__form">
            <div class="search-box__form__group">
                <div class="search-box__form__group__label label-warning">
                    <p>{{ warningLabelText }}</p>
                </div>
            </div>
            <div class="search-box__form__group" [class.disabled-group]="disableDocTytpe"
                 [attr.aria-disabled]="disableDocTytpe">
                <div class="search-box__form__group__label">
                    <label for="docType">{{ docTypeLabel }}</label>
                </div>
                <div class="search-box__form__group__control select" [class.disabled-control]="disableDocTytpe">
                    <select required [attr.aria-disabled]="disableDocTytpe" formControlName="docType" name="docType"
                            id="docType">
                        <option value="">{{ docTypePlaceholder }}</option>
                        @for (doc of documentTypes$ | async; track doc.value) {
                            <option [value]="doc.value">{{ doc.label }}</option>
                        }
                    </select>
                </div>
                @if(docType.invalid && docType.touched){
                    <div class="search-box__form__group__control--error">
                        <span>{{ docTypeError }}</span>
                    </div>
                }

            </div>
            <div class="search-box__form__group">
                <div class="search-box__form__group__label">
                    <label for="docNumber">{{ docNumLabel }}</label>
                </div>
                <div class="search-box__form__group__control">
                    <input required formControlName="docNumber" numbersOnly type="number" id="docNumber"
                           name="docNumber">
                </div>
                @if(docNumber.invalid && docNumber.touched){
                    <div class="search-box__form__group__control--error">
                        <span>{{ docNumberError }}</span>
                    </div>
                }

            </div>

            <div class="search-box__form__group">
                <div class="search-box__form__group__label">
                    <input class="checkbox" [class.error]="tratamientoDatos.invalid && tratamientoDatos.touched"
                           type="checkbox" formControlName="tratamientoDatos"><label for="tratamientoDatos">Acepto el <a
                    (click)="openTratamientoDatos()">{{ tratamientoDatosLabel }}</a></label>
                </div>
                @if(tratamientoDatos.invalid && tratamientoDatos.touched){
                    <div class="search-box__form__group__control--error">
                        <span>{{ tratamientoDatosError }}</span>
                    </div>
                }

            </div>
            <div class="search-box__form__group">
                <div class="search-box__form__group__label hidden">
                    <label for="g-recaptcha-response">reCaptcha</label>
                </div>
                <div class="search-box__form__group__control">
                    <ngx-turnstile
                        #captchaRef
                        [siteKey]="siteKey"
                        (resolved)="resolverCaptcha($event)"
                        formControlName="reCaptcha" theme="light"
                    ></ngx-turnstile>
                </div>
                @if(reCaptcha.invalid && reCaptcha.touched){
                    <div class="search-box__form__group__control--error">
                        <span>{{ reCaptchaError }}</span>
                    </div>
                }

            </div>


            <div class="search-box__form__group">
                <div class="search-box__form__group__control">
                    <button (click)="handleSubmitForm()" [attr.tabindex]="0"
                            [class.disabled]="!searchForm.valid">{{ submitLabel }}
                    </button>
                </div>
            </div>
        </form>
    } @else {
        <div style="width: 100%; height: 750px;">
            <iframe
                [src]="urlPreguntas"
                width="100%"
                height="100%"
                frameborder="0"
                title="Preguntas de seguridad">
            </iframe>
        </div>
    }
</div>
